import catchAsync from "../../utils/catchAsync";
import http from "./http";

export const gettingJobListApi = catchAsync(async (values) => {
  const data = await http.post(`/jobs/all-jobs`, values);

  return data;
});
export const jobDetailsApi = catchAsync(async (values) => {
  const data = await http.get(`/jobs/job-details/${values}`);

  return data;
});

export const jobReviewRatingCreateApi = catchAsync(async (values) => {
  const data = await http.post(`/jobs/add-job-review`, values);

  return data;
});

export const getjobReviewApi = catchAsync(async (values) => {
  const data = await http.get(`/jobs/job-reviews/${values}`);

  return data;
});
